module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "terms"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5%"
    }
  }, [_c('terms-of-use', {
    on: {
      "goback": _vm.back
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0eaf7130", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eaf7130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/terms.vue
// module id = 783
// module chunks = 0